import request from './request.client'

export default request

